import './HeroSectionComponent.css';

const HeroSectionComponent = () => {
    const heroText = () => <div className="hero-title yellow">WE ARE <span class="pulsate">PIXAY</span></div>

    return (
        <div id="pixay" className="viewport grid-parent hero-layout">
            {heroText()}
        </div>
    );
};

export default HeroSectionComponent;